import React, { Component } from "react";

import BurgerButton from "./BurgerButton";
import Context from "../../../context/Context";
import HotDesksPanel from "./HotDesksPanel";
import HotelsPanel from "./HotelsPanel";
import OfficePlan from "../../base/OfficePlan";
import PeoplePanel from "./PeoplePanel";
//import SideNav from "../../../common/components/SideNav";
import StatValue from "./StatValue";
import TabButton from "./TabButton";
import TabPanel from "./TabPanel";
import Topic from "../../../context/Topic";
import UnitsPanel from "./UnitsPanel";
import * as component from "../../../components/util/component";
import Skeleton from "react-loading-skeleton";

import {
  Container,
  SideNav,
  ButtonSection,
  SubTitle,
  ButtonLabel,
  CenteredWrapper
} from "../../styles/Work/workBar";

// calcite-react
import BurgerIcon from "calcite-ui-icons-react/HamburgerIcon";
import HotDeskIcon from 'calcite-ui-icons-react/DeskIcon';
import HotelIcon from "calcite-ui-icons-react/ServicesIcon";

export default class WorkBar extends Component {
  constructor(props) {
    super(props);
    this.state = component.newState({
      hasPlan: false,
      wasAppStarted: false
    });
  }

  componentDidMount() {
    component.own(this, [
      Topic.subscribe(Topic.AppStarted, params => {
        this.setState({ wasAppStarted: true });
      }),
      Topic.subscribe(Topic.PlanModified, params => {
        this.refreshStats();
      }),
      Topic.subscribe(Topic.PlanOpened, params => {
        this.setState({ hasPlan: true });
        this.refreshStats();
      }),
      Topic.subscribe(Topic.ReloadViews, params => {
        this.setState({ hasPlan: false });
      }),
      Topic.subscribe(Topic.ViewsReloaded, params => {
        this.setState({ wasAppStarted: true });
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  refreshStats = () => {
    const plan = OfficePlan.getActive();
    if (plan) plan.refreshStats();
  };

  render() {
    const { hasPlan } = this.state;
    const i18n = Context.instance.i18n;
    const navKey = "i-spaceplanner-workbar-nav";
    const panelOpenClassName = "i--workbar-panel-open";
    return (
      <Container>
        <SideNav className="i-side-nav">
          <ButtonSection key="burger" className="i--burger">
            <BurgerButton
              key="burger"
              tabKey="burger"
              navKey={navKey}
              panelOpenClassName={panelOpenClassName}
              title={i18n.spaceplanner.menu.burger.label}
              disabled={!this.state.wasAppStarted}
            >
              <BurgerIcon size="32" />
            </BurgerButton>
          </ButtonSection>
          <ButtonSection>
            <SubTitle title={i18n.spaceplanner.menu.notAssigned.label}>
              {i18n.spaceplanner.menu.notAssigned.label}
            </SubTitle>
            {hasPlan ? (
              <>
                <TabButton
                  key="people"
                  tabKey="people"
                  navKey={navKey}
                  panelOpenClassName={panelOpenClassName}
                  title={i18n.spaceplanner.assets.people.title}
                >
                  <StatValue statKey={OfficePlan.Stat_PeopleUnassigned} />
                  <ButtonLabel>
                    {i18n.spaceplanner.assets.people.title}
                  </ButtonLabel>
                </TabButton>
                <TabButton
                  key="units"
                  tabKey="units"
                  navKey={navKey}
                  panelOpenClassName={panelOpenClassName}
                  title={i18n.spaceplanner.assets.units.title}
                >
                  <StatValue statKey={OfficePlan.Stat_UnitsUnassigned} />
                  <ButtonLabel>
                    {i18n.spaceplanner.assets.units.title}
                  </ButtonLabel>
                </TabButton>
              </>
            ) : (
              <CenteredWrapper>
                <Skeleton count={2} height={64} width={64} />
              </CenteredWrapper>
            )}
          </ButtonSection>
          <ButtonSection>
            <SubTitle title={i18n.spaceplanner.menu.assignedTo.label}>
              {i18n.spaceplanner.menu.assignedTo.label}
            </SubTitle>
            {hasPlan ? (
              <>
                <TabButton
                  key="hotDesks"
                  tabKey="hotDesks"
                  navKey={navKey}
                  panelOpenClassName={panelOpenClassName}
                  title={i18n.spaceplanner.hotdeskAreas.caption}
                >
                  <HotDeskIcon />
                  <ButtonLabel>
                    {i18n.spaceplanner.hotdeskAreas.buttonCaption}
                  </ButtonLabel>
                </TabButton>
                <TabButton
                  key="hotels"
                  tabKey="hotels"
                  navKey={navKey}
                  panelOpenClassName={panelOpenClassName}
                  title={i18n.spaceplanner.hotelAreas.caption}
                >
                  <HotelIcon />
                  <ButtonLabel>
                    {i18n.spaceplanner.hotelAreas.buttonCaption}
                  </ButtonLabel>
                </TabButton>
              </>
            ) : (
              <CenteredWrapper>
                <Skeleton count={2} height={64} width={64} />
              </CenteredWrapper>
            )}
          </ButtonSection>
        </SideNav>
        {hasPlan && (
          <>
            <TabPanel key="people" tabKey="people" navKey={navKey}>
              <PeoplePanel
                panelKey="spaceplanner/workbar/PeoplePanel"
                sourceKey="People"
                layerCaption={i18n.spaceplanner.assets.people.unassignedTitle}
                filterTooltip={
                  i18n.spaceplanner.assets.people.unassignedFilterTooltip
                }
              />
            </TabPanel>
            <TabPanel key="units" tabKey="units" navKey={navKey}>
              <UnitsPanel
                panelKey="spaceplanner/workbar/UnitsPanel"
                sourceKey="Units"
                layerCaption={i18n.spaceplanner.assets.units.unassignedTitle}
                filterTooltip={
                  i18n.spaceplanner.assets.units.unassignedFilterTooltip
                }
              />
            </TabPanel>
            <TabPanel key="hotDesks" tabKey="hotDesks" navKey={navKey}>
              <HotDesksPanel panelKey="spaceplanner/workbar/HotDesksPanel" />
            </TabPanel>
            <TabPanel key="hotels" tabKey="hotels" navKey={navKey}>
              <HotelsPanel panelKey="spaceplanner/workbar/HotelsPanel" />
            </TabPanel>
          </>
        )}
      </Container>
    );
  }
}
